/* Table with fixed layout */

.sc-table-fixed {
  table-layout: fixed;

  td, th {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

/* Table with sticky header */

.sc-table-sticky {
  position: relative;

  th {
    position: sticky;
    top: 0;
    z-index: 1;
  }
}
